import { useStaticQuery, graphql } from "gatsby"

import { DEFAULT_STOREFRONT } from "../cart/constants"
import { parseStoryblokDate } from "../utils/storyblok"
import { selectSdkProduct } from "../utils/V2/consolidateItem"

import { useMemo, useCallback } from "react"

export const useParseStoryBlokDate = (date?: string): Date | null => {
  const parsedDate = useMemo(() => parseStoryblokDate(date), [date])

  return parsedDate
}

export const useGetProducts = (): {
  allProduct: { edges: { node: YocoCom.SdkProduct }[] }
} => {
  const products = useStaticQuery(graphql`
    query Products {
      allProduct {
        edges {
          node {
            id
            externalId
            sku
            name
            short_name
            image
            description
            short_description
            unit_price_formatted
            unit_price_currency
            unit_price
            original_unit_price
            is_discounted
            is_available_on_payment_terms
            type
            is_listed_in_catalogue
            max_quantity_per_cart
            tax_policy
            tax_rate
            ribbon_text
            ribbon_class
            third_party_reviews {
              description
              name
              rating
              url
            }
            reviewsRating
            reviewsCount
            storefronts
            reason_not_available
            sdkIndex
          }
        }
      }
    }
  `)

  return products
}

export const useGetProductBySku = (): ((
  sku: string,
  storefront?: string
) => YocoCom.SdkProduct | null) => {
  const products = useGetProducts()

  const getProductBySku = useCallback(
    (sku: string, storefront = DEFAULT_STOREFRONT) =>
      selectSdkProduct(
        products.allProduct.edges.map((product) => product.node),
        sku,
        storefront
      ) ?? null,
    [products]
  )

  return getProductBySku
}
